
import ProjectTemplateVue from '../components/ProjectTemplate.vue';
import dialog from '@/modules/globalModule/components/dialog';
import { useProjectManagerStore } from '../store';
import { defineComponent } from 'vue';
import SearchWImage from '@/modules/globalModule/components/SearchWImage.vue';
import {
  V4UUID,
  allWorkspacesStateSingleton,
  deleteWorkspace
} from '@/firebase/database';
import SavedWorkspace from '../components/SavedWorkspace.vue';
import { useGlobalStore } from '@/modules/globalModule/store';
import authStore from '@/firebase/auth';
import Stripe from 'stripe';
import { getStripeCustomerSubscription } from '@/stripe/stripeSubscription';
import { set } from 'firebase/database';

export default defineComponent({
  name: 'ProjectsPage',
  components: {
    ProjectTemplateVue,
    SearchWImage,
    SavedWorkspace
  },
  data(): {
    projectOptionsVisible: boolean;
    projectSearchText: string;
    userSubscription: undefined | Stripe.Subscription;
    projectSearchVisible: boolean;
    canCreate: boolean;
    pmStore: any;
    workspacesInfo: any;
  } {
    return {
      projectOptionsVisible: false,
      projectSearchText: '',
      projectSearchVisible: false,
      pmStore: useProjectManagerStore(),
      workspacesInfo: allWorkspacesStateSingleton(),
      userSubscription: undefined,
      canCreate: false
    };
  },
  async mounted() {
    this.pmStore.loadWorkspaces();
    this.pmStore.loadTemplates();
    if (!authStore.stripeId) {
      setTimeout(async () => {
        if (!authStore.stripeId) return;
        try {
          this.userSubscription = await getStripeCustomerSubscription(
            authStore.stripeId
          );
        } catch (e) {}
        this.setCanCreate();
      }, 2000);
      return;
    }
    try {
      this.userSubscription = await getStripeCustomerSubscription(
        authStore.stripeId
      );
    } catch (e) {}
    this.setCanCreate();
  },
  methods: {
    setCanCreate(): void {
      this.canCreate = this.pmStore.canCreateWorkspace(this.userSubscription);
    },
    editProjects(): void {
      this.projectOptionsVisible = !this.projectOptionsVisible;
    },
    settings(): void {
      this.$router.push('/projectManager/settings');
    },
    showProject(projectName: string): boolean {
      return projectName
        .toLowerCase()
        .includes(this.projectSearchText.toLowerCase());
    },
    searchProjects(): void {
      this.projectSearchVisible = !this.projectSearchVisible;
    },
    onSearchInput(e: Event) {
      this.projectSearchText = (e.target as HTMLInputElement).value;
    },
    async deleteProject(name: string, id: V4UUID): Promise<void> {
      let confirmed = await dialog
        .okText('Yes')
        .cancelText('No')
        .confirm('Are you sure you want to delete the project "' + name + '"?');
      if (confirmed) {
        this.pmStore.removeWorkspace(id);
        deleteWorkspace(id);
      }
      this.setCanCreate();
    },
    createNewProject(): void {
      this.$router.push('projectManager/newWorkspace');
    },
    openWorkspace(workspaceId: V4UUID): void {
      const globalStore = useGlobalStore();
      globalStore.loadWorkspace(workspaceId);
      this.$router.push('/controlCenter/' + workspaceId);
    }
  }
});
